import { render, staticRenderFns } from "./courseDataeight.vue?vue&type=template&id=5bc54692&scoped=true"
import script from "./courseDataeight.vue?vue&type=script&lang=js"
export * from "./courseDataeight.vue?vue&type=script&lang=js"
import style0 from "./courseDataeight.vue?vue&type=style&index=0&id=5bc54692&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc54692",
  null
  
)

export default component.exports